/**
 * M21 #7 — 검수 상태 파생 헬퍼 (컴포넌트와 분리해 fast-refresh 경고 회피).
 */

import type { RecordOut } from "@/lib/api/jobs";

export type ReviewDisplayState = "none" | "running" | "passed" | "needsReview" | "confirmed";

/** 파생 검수 상태별 i18n 라벨 키 (배지·필터에서 공용으로 사용해 라벨 drift 방지). */
export const REVIEW_STATE_I18N_KEYS: Record<ReviewDisplayState, string> = {
  none: "records.review.status.none",
  running: "records.review.status.aiRunning",
  passed: "records.review.status.aiPassed",
  needsReview: "records.review.status.aiNeedsReview",
  confirmed: "records.review.status.confirmed",
};

/**
 * Record 의 review_status/ai_review 로부터 표시 상태를 파생.
 * 반려 건도 같은 단계로 표시한다 — 반려 판정도 1차 검수 대상이다(반려 표시는 상태 칸).
 */
export function deriveReviewState(record: RecordOut | null | undefined): ReviewDisplayState {
  if (!record) return "none";
  if (record.review_status === "confirmed") return "confirmed";
  switch (record.review_status) {
    case "ai_passed":
      return "passed";
    case "ai_needs_review":
      return "needsReview";
    case "human_done":
      if (record.ai_review == null) return "running";
      return record.ai_review.verdict === "pass" ? "passed" : "needsReview";
    default:
      return "none";
  }
}

/** 2차 검수 완료(최종 사인오프) 체크가 가능한 상태인지 — AI 검토가 끝났을 때(반려 건 포함). */
export function canConfirmReview(record: RecordOut | null | undefined): boolean {
  const s = deriveReviewState(record);
  return s === "passed" || s === "needsReview" || s === "confirmed";
}
